/**
 *  localStorage Progress Bar
 */
const progress = () => {

  // localStorage.clear()

  // 重複を防ぐため、キーの前にシーズンを設定
  const season = '22ss'

  const isEn = document.querySelector('body').classList.contains('is-en')

  let page = location.pathname.split('/')

  if (!isEn) {
    page = season + '-' + page[page.length - 2]
  } else {
    page = season + '-' + page[page.length - 2] + '-en'
  }

  // console.log(page)

  localStorage.setItem(page, 'read')

  // alert(localStorage.getItem('21fw-about'))

  const items = document.querySelectorAll('.c-card--progress')

  for (let i = 0; i < items.length; i++) {

    let url = items[i].getAttribute('href').split('/')[5]

    // console.log(url)

    if (!isEn) {
      url = season + '-' + url
    } else {
      url = season + '-' + url + '-en'
    }

    if (localStorage.getItem(url)) {
      items[i].classList.add('c-card--readed')
    }

  }

  const count = document.querySelector('.js-progressCount')
  const readItems = document.querySelectorAll('.is-header .c-card--readed')
  count.textContent = readItems.length

  const total = document.querySelector('.js-progressTotal')
  const headerItems = document.querySelectorAll('.is-header .c-card--progress')
  total.textContent = headerItems.length

  const progressBar = document.querySelector('.js-progressBar')
  progressBar.style.width = Math.floor(readItems.length / headerItems.length * 100) + '%'

}

export { progress };
